import isNil from 'lodash/isNil';
import {SOURCES} from '~/types/sources';
import PropTypes from 'prop-types';

const ArticleText = ({source, number}) => {
  const source_label = SOURCES[source] ?? source;

  return (
    <>
      {source_label}
      {!isNil(number) && (
        <>
          {isNil(source_label) ? null : <>&nbsp;&middot;&nbsp;</>}
          <>{number}</>
        </>
      )}
    </>
  );
};
ArticleText.propTypes = {
  source: PropTypes.any,
  number: PropTypes.any,
};

export default ArticleText;
